/* =====================================================================
   Pen Tech – projector lamp meter (snippets/pt-lamp-meter.liquid)
   Updates every [data-pt-lamp] meter when the shopper picks another
   variant (some projectors sell lamp hours as variants). Each meter
   carries its own JSON: {life, base, v: {variantId: hours|null}, t: {main, past, pct}}.
   Loaded only by meters whose product sells lamp hours as variants.
   ===================================================================== */
(function () {
  'use strict';
  if (window.PTLamp) return;

  var TONES = ['pt-lamp--good', 'pt-lamp--mid', 'pt-lamp--low'];

  function fmt(n) {
    try { return Number(n).toLocaleString('en-US'); } catch (e) { return String(n); }
  }

  function fill(tpl, used, life, pct) {
    return String(tpl || '')
      .replace(/%used%/g, fmt(used))
      .replace(/%life%/g, fmt(life))
      .replace(/%pct%/g, String(pct));
  }

  function readData(el) {
    if (el.__ptLamp !== undefined) return el.__ptLamp;
    var node = el.querySelector('script[data-pt-lamp-data]');
    var data = null;
    if (node) {
      try { data = JSON.parse(node.textContent); } catch (e) { data = null; }
    }
    el.__ptLamp = data;
    return data;
  }

  function render(el, id) {
    var d = readData(el);
    var key = String(id);
    if (!d || !d.v || !Object.prototype.hasOwnProperty.call(d.v, key)) return;
    var used = d.v[key];
    if (used === null || used === undefined) used = d.base;
    var life = Number(d.life) || 0;
    if (used === null || used === undefined || !life) { el.hidden = true; return; }
    used = Number(used) || 0;
    el.hidden = false;

    var left = Math.max(0, life - used);
    var pct = Math.max(0, Math.min(100, Math.round(left * 100 / life)));
    var past = used > life;
    var tone = pct >= 60 ? 'good' : pct >= 30 ? 'mid' : 'low';
    var t = d.t || {};

    TONES.forEach(function (c) { el.classList.remove(c); });
    el.classList.add('pt-lamp--' + tone);

    var text = el.querySelector('[data-pt-lamp-text]');
    if (text) text.textContent = fill(past ? t.past : t.main, used, life, pct);
    var badge = el.querySelector('[data-pt-lamp-pct]');
    if (badge) badge.textContent = fill(t.pct, used, life, pct);
    var bar = el.querySelector('[data-pt-lamp-fill]');
    if (bar) bar.style.setProperty('--pt-lamp', pct + '%');
    var hint = el.querySelector('[data-pt-lamp-hint]');
    if (hint) hint.hidden = !(tone === 'low' && !past);
  }

  function update(id) {
    if (!id) return;
    var meters = document.querySelectorAll('[data-pt-lamp]');
    for (var i = 0; i < meters.length; i++) render(meters[i], id);
  }

  function urlVariant() {
    try { return new URLSearchParams(window.location.search).get('variant'); } catch (e) { return null; }
  }

  // Minimog (assets/product-info.js) fires this after every variant change.
  document.addEventListener('variant:changed', function (e) {
    var v = e && e.detail && e.detail.variant;
    if (v && v.id) update(v.id);
  });

  // Plain product forms (quick view, other templates): a select/radio named "id".
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (el && el.name === 'id' && (el.tagName === 'SELECT' || el.tagName === 'INPUT')) update(el.value);
  });

  // Theme editor: a reloaded section starts from the server state; sync it to the URL variant.
  document.addEventListener('shopify:section:load', function () {
    var id = urlVariant();
    if (id) update(id);
  });

  window.PTLamp = { update: update };
})();
